module.exports = __WEBPACK_EXTERNAL_MODULE_20__;


//////////////////
// WEBPACK FOOTER
// external "CoveoForSitecoreUserContext"
// module id = 20
// module chunks = 0